/* eslint-disable jsx-a11y/media-has-caption */

import styles from '../GalleryModal.module.scss';
import type { GalleryEmbedded } from '../utils';

interface GalleryModalVideoDefaultProps {
  video: GalleryEmbedded;
}

const GalleryModalVideoDefault: React.FC<GalleryModalVideoDefaultProps> = ({ video }) => {
  const videoElement = (
    <video controls className={styles.video} title={`${video.alt} ${video.index + 1}`}>
      <source src={video.url} type="video/mp4" />
    </video>
  );

  return video.caption ? (
    <figure className={styles.figure}>
      {videoElement}
      <figcaption className={styles.caption}>{video.caption}</figcaption>
    </figure>
  ) : (
    videoElement
  );
};

export default GalleryModalVideoDefault;
